<div class="dms-mat-folders-scroll-area" [irisOverlayLoader]="foldersLoading()">
  <mat-tree class="dms-mat-folders"
    [dataSource]="dataSource()"
    [levelAccessor]="levelAccessor"
    [trackBy]="trackBy"
  >
    <mat-tree-node *matTreeNodeDef="let folderItemNode"
                    matTreeNodePadding
                    matTreeNodePaddingIndent="15"
                    #treeNodeWithChildren
                    [isExpandable]="folderItemNode.expandable"
                    [isExpanded]="isExpanded(folderItemNode)"
                    (expandedChange)="toggleNode(folderItemNode, $event)"
                    [class.selected]="isSelected(folderItemNode.item)()"
                    (click)="folderTreeItemClicked(folderItemNode.item)"
                    (dblclick)="dblClickToggleFolder(folderItemNode)"
                    irisDragAndDrop
                    [draggable]="folderDraggable(folderItemNode.item)"
                    [droppable]="!external()"
                    [dragData]="{ folderId: folderItemNode.item?.id }"
                    [dropData]="{ folderId: folderItemNode.item?.id }"
                    (dropped)="dataDropped($event, folderItemNode.item)"
                    cdkDropList
                    [cdkDropListDisabled]="!externalDrop()"
                    [cdkDropListData]="folderItemNode"
                    [cdkDropListSortingDisabled]="true"
                    (cdkDropListDropped)="cdkDropListDropped($event, folderItemNode.item)"
                    class="dms-mat-folders-item-node"
                    data-test="dms-folders-tree">
      <div class="dms-mat-folders-item">
        <sk-button
          data-test="dms-folders-expand-tree-button"
          [appearance]="'text'"
          class="folder-btn"
          [class.no-expander]="!showExpander(folderItemNode.item)"
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + folderItemNode.item.title"
        >
          <ng-template buttonPrefix>
            @if (showExpander(folderItemNode.item)) {
              <i class="icon far fa-fw expander"
                [hidden]="folderItemNode.item.isTrashBin"
                [class.fa-angle-right]="!isExpanded(folderItemNode)"
                [class.fa-angle-down]="isExpanded(folderItemNode)"
              ></i>
            }
            <ng-container [ngTemplateOutlet]="folderIcon" [ngTemplateOutletContext]="{ node: folderItemNode }"></ng-container>
          </ng-template>
        </sk-button>
        <ng-container [ngTemplateOutlet]="folderInfo" [ngTemplateOutletContext]="{ node: folderItemNode, element: treeNodeWithChildren }"></ng-container>
      </div>
    </mat-tree-node>
  </mat-tree>

  @if (showNoFoldersMessage()) {
    <span class="no-folders">
      {{ 'label.dms.NoFoldersOrFiles' | translate }}
    </span>
  }

  @if (hasNoSelectedProject) {
    <iris-empty-content-view
      label="label.NoProjectSelected"
      message="text.dms.PleaseSelectProject"
    ></iris-empty-content-view>
  }
</div>

<ng-template #folderIcon let-node="node">
  @if (node.item.customIconClass && !node.item.isLocked) {
    <i class="custom-icon"
      [class.virtual-lock]="node.item.isParentLocked"
      [ngClass]="node.item.customIconClass"
      [style.color]="node.item?.normilizedColor"
    ></i>
  } @else {
    <i class="icon fa-fw folder-icon"
      [ngClass]="getFolderIconClass(node.item)"
      [style.color]="node.item?.color"
    ></i>
  }
</ng-template>
<ng-template #folderInfo let-node="node" let-element="element">
  <span
    class="folder-name"
    [class.system-folder]="node.item.isSystem"
    [matTooltip]="getFolderName(node.item)"
    [matTooltipPosition]="tooltipPosition"
    [matTooltipDisabled]="hideForTablet"
    matTooltipClass="dms-folder-tree-tooltip"
  >
    @if (node.item.isLocked) {
      <i class="fas fa-lock dms-folder-tree-lock-icon-color"></i>
    }
    {{ getFolderName(node.item) }}
    @if (!external() && hasFolderInProgressAction(node.item?.id)()) {
      <sk-progress-bar class="w-100" mode="indeterminate"></sk-progress-bar>
    }
  </span>

  @if (!external() && !initialModalView && !node.item.isTrashBin && !node.item.isRecentFilesFolder) {
    <iris-dms-folder-actions-menu
      class="menu-btn"
      [openFolderOnShowInfo]="true"
      [folder]="node.item"
    ></iris-dms-folder-actions-menu>
  }

  @if (!external() && initialModalView) {
    <iris-dms-add-folder-button
      [hidden]="(showAddFolderBtn$(node, element) | async) === false"
      class="add-folder-btn"
      cssClass="p-1"
      [folderId]="node.item?.id"
      [iconOnly]="true"
      [setSelected]="true"
      [isMatMenu]="false"
    ></iris-dms-add-folder-button>
  }
</ng-template>
